import { useState } from "react";
import { Mail, X, Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth-context";
import { useResendVerificationEmail } from "@/hooks/useAuthExtras";
import { toast } from "sonner";

export default function EmailVerificationBanner() {
  const { user } = useAuth();
  const resend = useResendVerificationEmail();
  const [dismissed, setDismissed] = useState(false);
  const [sent, setSent] = useState(false);

  if (!user || user.email_verified || dismissed) return null;

  return (
    <div className="flex items-center gap-2 border-b border-border bg-secondary/60 px-4 py-2 text-xs">
      <Mail className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
      <span className="flex-1 text-muted-foreground">
        {sent ? "Verification email sent - check your inbox." : "Please verify your email address."}
      </span>
      {!sent && (
        <button
          className="font-medium text-foreground disabled:opacity-50"
          disabled={resend.isPending}
          onClick={async () => {
            try {
              await resend.mutateAsync();
              setSent(true);
            } catch {
              toast.error("Couldn't resend the verification email");
            }
          }}
        >
          {resend.isPending ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Resend"}
        </button>
      )}
      <button onClick={() => setDismissed(true)}>
        <X className="h-3.5 w-3.5 text-muted-foreground" />
      </button>
    </div>
  );
}
